import React from 'react';
import { useAppSelector } from 'redux/hooks/reduxHooks';
import { CircularProgress, Backdrop } from '@mui/material';
import { selectIsLoading } from 'redux/selectors/selectors';

const LoadingLayer: React.FC = () => {
  const isLoading = useAppSelector(selectIsLoading);

  return (
    <Backdrop open={isLoading}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default LoadingLayer;
